export default __webpack_public_path__ + "static/gatsby-icon-4f6aa398dc646bc3c49dd27654b475a1.png";